import { IsEnum, IsNumber, IsString } from 'class-validator';

export enum ReceptionItemStatus {
  CANCELED = 'CANCELED',
  RECEIVED = 'RECEIVED',
  PENDING_INTEGRATION = 'PENDING_INTEGRATION',
  INTEGRATED = 'INTEGRATED',
  INTEGRATION_ERROR = 'INTEGRATION_ERROR',
}

export class ReceivedItemVm {
  @IsString()
  receptionId: string;

  @IsString()
  warehouseId: string;

  @IsString()
  batch: string;

  @IsString()
  serialNumber: string;

  @IsString()
  orderItemId: string;

  @IsString()
  productName: string;

  @IsString()
  productSku: string;

  @IsString()
  orderItemExternalId: string;

  @IsEnum(ReceptionItemStatus)
  status: ReceptionItemStatus;

  @IsString()
  receiverId: string;

  @IsString()
  receiverName: string;

  @IsNumber()
  quantity: number;

  @IsString()
  integrationError: string;
}
